import PropTypes from 'prop-types';
import { decl } from '@yandex-lego/i-bem-react';

export default decl({
    block: 'image',
    tag: 'img',
    attrs: function attrs(_ref) {
        var url = _ref.url,
            alt = _ref.alt,
            width = _ref.width,
            height = _ref.height;

        return {
            alt: alt,
            width: width,
            height: height,
            onClick: this.props.onClick,
            src: url || 'https://yastatic.net/lego/_/La6qi18Z8LwgnZdsAr1qy1GwCwo.gif'
        };
    }
}, {
    propTypes: {
        url: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number
    }
});